import { logger } from "../services/telemetry";
import { firebaseSignOut } from "./firebase";
import { IDENTITY_BASE_URL } from "./config";
import { clearPostAuthIntent } from "./postAuthIntent";
import { resetUser } from "../analytics/tracking";

/* Full sign-out: end the identity session (POST /identity/end-session clears
 * the session cookie, sent via credentials: "include") AND clear the persisted
 * Firebase user — otherwise its refresh token lingers in IndexedDB and could
 * silently re-mint ID tokens on a shared machine. The caller reloads
 * afterwards so the gate re-renders against the cleared session and shows the
 * login screen. Failures are non-fatal — the reload still re-runs the gate. */
export async function logout(): Promise<void> {
  // Drop any pending sign-up welcome intent so it can't misroute whoever signs
  // in next on this browser (the intent is per-signup, not per-device).
  clearPostAuthIntent();

  // Clear the Amplitude user/device identity so the next user on this browser
  // isn't attributed to the one signing out. Runs before the guard below so it
  // happens even when there's no identity backend configured (dev/no-auth).
  resetUser();

  if (!IDENTITY_BASE_URL) return;

  try {
    await fetch(`${IDENTITY_BASE_URL}/identity/end-session`, {
      method: "POST",
      credentials: "include",
    });
  } catch (err) {
    logger.warn(
      err instanceof Error ? err : new Error(String(err)),
      "Sign-out request failed",
    );
  }
  try {
    await firebaseSignOut();
  } catch (err) {
    logger.warn(
      err instanceof Error ? err : new Error(String(err)),
      "Firebase sign-out failed",
    );
  }
}
